export default "__VITE_ASSET__2ac70d69__"